<script>
	import { getText } from '../../../../share/utils';
</script>

<div class="page-special-car-ui marginbox">
	<div class="flex structure">

		<div class="flex row structure-1">
			<div class="flex element text">
				<h3 class="caption">{getText("16.06.01_h3")}</h3>
			</div>
			<div class="flex element">
				<img loading="lazy" alt="Human Machine Interface - Menu" src="./../img/16.Individuelle_Klasse/06.car_ui/menu.webp">
			</div>
		</div>

		<div class="flex row structure-2">
			<div class="flex element">
				<img loading="lazy" alt="Human Machine Interface - Navi" src="./../img/16.Individuelle_Klasse/06.car_ui/navi.webp">
			</div>
			<div class="flex element text">
				<p class="caption">{getText("16.06.02_caption")}</p>
			</div>
		</div>
	</div>
</div>

<style lang="scss">
	@import "../../../../style/mixins";
	@import "../../../../style/variables";
	
	img {
		width: 100%;
		margin: 0;
		padding: 0;
	}
	
	.page-special-car-ui {
		margin-top: $media-gap;

		.flex {
			display: flex;
			box-sizing: border-box;
		}
		
		.row {
			flex-flow: row wrap;
		}
		
		.col {
			flex-flow: column wrap;
		}
		
		.element {
			min-width: 100px;
		}
		
		.commercial {
			position: relative;
			width: 100%;
			height: 100%;
		}
		
		.content {
			flex: 1 100%;
		}
		
		.structure {
			flex-flow: row wrap;

			@include for-tablet-portrait-up {
				gap: $spacing-mobile;
			}

			.element {
				width: 100%;
				margin-bottom: $media-gap;
				height: fit-content;
			}
		}
		
		.structure-1 {
			width: 100%;
			padding: 0;
			position: relative;
			
			@include for-tablet-portrait-up {
				flex-flow: column nowrap;

				.element {
					justify-content: end;
				}
			}
		}
		
		.structure-2 {
			@include for-tablet-portrait-up {
				width: 50%;
			}
		}


		.structure-1,
		.structure-2 {
			justify-content: space-between;

			@include for-tablet-portrait-up {
				flex: 1;

				.caption {
					margin-bottom: unset;
				}
			}
		}

		.text {
			margin: 0;
		}
	}

	:global(.page_individuelle_klasse.useCustomCss) .blue {
		color: #E80666;
	}
</style>
